import React, { useEffect, useMemo, useState } from "react"
import { get, isEmpty, isFinite } from "lodash"

import { APIResponse } from "redux/apis/types"
import { ETFTemplate } from "components/templates/domestic/etf"
import APIs from "redux/apis"
import { EXCHANGE, SECURITY_TYPE, PAGE_NUM } from "config/const"
import * as Formatter from "utils/Formatter"
import { checkIsSp } from "utils/util"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import uuid from "uuid/v4"
import { useDispatch } from "react-redux"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const Etf: React.FC = () => {
  const [currentContent, changeContent] = useState<number>(0)
  const [data, setData] = useState<any>([])
  const [activeTab, changeTab] = useState<number>(0)
  const [detailsData, setDetailsData] = useState<APIResponse.Res>([])
  const [currentPage, changePage] = useState(0)
  const [currentData, changeData] = useState<number>(0)
  const [rateData, setRateData] = useState([])
  const [calcData, setCalcData] = useState(0)
  const [numericSpinnerStatus, changeNumericSpinnerStates] = useState<
    number | string
  >("")
  const [refreshFlag, setRefreshFlag] = useState(false)
  const isSp = checkIsSp()
  const dispatch = useDispatch()
  const industryChartId = useMemo(() => {
    return uuid()
  }, [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  //ADR:レート取得（初期値）
  const setRate = async () => {
    await dispatch(pageLoadRegist(industryChartId, true))
    const _rateData = await APIs.SymbolDetail.PriceList({
      Name: "Top.FX.JPY",
    })
    const price = get(_rateData, "ResultList[0]Price") || 0
    const _rate = Formatter.decimalConverter(
      price,
      "floor",
      get(_rateData, "ResultList[0]NumberOfDecimals")
    )

    setRateData(get(_rateData, "ResultList[0]"))
    _rate ? setCalcData(_rate) : setAdr()

    await dispatch(pageLoadRegist(industryChartId, false))
  }

  //ADR:テーブルの情報取得
  const setAdr = async (rateNum?: number) => {
    await dispatch(pageLoadRegist(industryChartId, true))
    const params = isSp
      ? {
          Rate: rateNum || calcData || null,
        }
      : {
          Rate: rateNum || calcData || null,
          _take: PAGE_NUM.PAGE_20,
          _skip: currentPage * PAGE_NUM.PAGE_20,
        }
    const res = await APIs.SymbolDetail.ADRList(params)
    setData(res)
    await dispatch(pageLoadRegist(industryChartId, false))
  }

  //ETFかREITの情報取得
  const setEtfOrReit = async () => {
    await dispatch(pageLoadRegist(industryChartId, true))
    const limitType = currentContent === 0 ? 1 : 2
    const exchange = activeTab === 0 ? 1 : 3
    const params = isSp
      ? {
          TargetSecurityTypes: 1,
          Exchange: exchange,
          LimitType: limitType,
        }
      : {
          TargetSecurityTypes: 1,
          Exchange: exchange,
          LimitType: limitType,
          _take: PAGE_NUM.PAGE_10,
          _skip: currentPage * PAGE_NUM.PAGE_10,
        }
    const res = await APIs.SymbolDetail.SymbolList(params)
    const dataList = get(res, "ResultList")[currentData]
    if (!isEmpty(dataList)) {
      const symbolDetail = await APIs.SymbolDetail.SymbolDetail({
        Symbol: get(dataList, "Symbol"),
        Exchange: get(dataList, "Exchange", EXCHANGE.TSE.id),
        SecurityType: get(dataList, "SecurityType", SECURITY_TYPE.Equity.id),
      })
      setDetailsData(symbolDetail)
    }
    setData(res)
    await dispatch(pageLoadRegist(industryChartId, false))
  }

  const requestApi = async () => {
    if (currentContent === 2) {
      if (!calcData) {
        setRate()
      } else {
        setAdr()
      }
    } else {
      setEtfOrReit()
    }
  }

  useEffect(() => {
    if (refreshFlag) return
    requestApi()
  }, [currentContent, currentPage, currentData])

  useEffect(() => {
    isPageLoading && requestApi()
  }, [isPageLoading])

  useEffect(() => {
    if (refreshFlag) {
      if (currentContent === 2) {
        setAdr(Number(numericSpinnerStatus))
        setCalcData(Number(numericSpinnerStatus))
      } else {
        setEtfOrReit()
      }
      //ADRを呼ぶ際に、setCalcDataをすると二重にAPIが呼び出されてしまうので、フラグを落とすのを少々遅らせる。
      setTimeout(() => {
        setRefreshFlag(false)
      }, 500)
    }
  }, [refreshFlag])

  useEffect(() => {
    if (refreshFlag || currentContent !== 2) return
    setAdr()
  }, [calcData])

  return (
    <ETFTemplate
      data={get(data, "ResultList")}
      setData={setData}
      totalCount={get(data, "TotalCount")}
      currentContent={currentContent}
      changeContent={changeContent}
      activeTab={activeTab}
      changeTab={changeTab}
      detailsData={detailsData}
      currentPage={currentPage}
      changePage={changePage}
      currentData={currentData}
      changeData={changeData}
      rateData={rateData}
      calcData={calcData}
      setCalcData={setCalcData}
      numericSpinnerStatus={numericSpinnerStatus}
      changeNumericSpinnerStates={changeNumericSpinnerStates}
      refreshFlag={refreshFlag}
      setRefreshFlag={setRefreshFlag}
    />
  )
}
